import React from 'react';


const DividerLine = () => {
    
    return (
        <div className='divider-line' />
    );
};

export default DividerLine 